
import { defineComponent, PropType, ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import {
  AccountStatus,
  BaseInfoService,
  DefenseStatusLabel
} from '@/views/dashboard/group/client/terminal-info/base-info/base-info.service'
import { Accounts, BaseInfoRes } from '@/views/dashboard/group/client/terminal-info/terminal-info.service'
import { formatDuration, formatTimeStamp } from '@/utils/time'
import { TerminalLoginStatus } from '@/views/dashboard/_enum/terminal-login-status'
import { ElMessage, ElMessageBox } from 'element-plus'

export default defineComponent({
  props: {
    compData: {
      type: Object as PropType<BaseInfoRes>,
      default: {} as BaseInfoRes
    }
  },

  setup (props, context) {
    const { t, locale } = useI18n()
    const injector = useReflectiveInjector([BaseInfoService])
    const service = injector.get(BaseInfoService)

    const isLoading = ref(false)

    const terminalLoginLabelMap = computed(() => {
      void locale.value
      return {
        [TerminalLoginStatus.online]: t('responseHandle.terminalLoginOnline'),
        [TerminalLoginStatus.offline]: t('responseHandle.terminalLoginOffline'),
        [TerminalLoginStatus.quit]: t('groupClient.terminalInfoDetail.terminalLoginQuit'),
      } as Record<number, string>
    })

    const accountStatusLabelMap = computed(() => {
      void locale.value
      return {
        [AccountStatus.enable]: t('responseHandle.accountStatusEnabled'),
        [AccountStatus.disable]: t('responseHandle.accountStatusDisabled'),
        [AccountStatus.disabling]: t('responseHandle.accountStatusDisabling'),
        [AccountStatus.enabling]: t('responseHandle.accountStatusEnabling'),
      } as Record<number, string>
    })

    const tipOnlineOnly = computed(() => {
      void locale.value
      return t('groupClient.terminalInfoDetail.tipOnlineOnly')
    })

    function changTab (tab) {
      context.emit('changeTab', tab)
    }

    function disableAccount (item: Accounts) {
      const enableAccountNum = props.compData.accounts.filter(v => v.status === AccountStatus.enable).length
      if (enableAccountNum <= 1) {
        ElMessage.error(t('responseHandle.cannotDisableKeepOne'))
        return
      }
      ElMessageBox.confirm(t('responseHandle.confirmDisableAccount'), t('groupClient.terminalInfoDetail.dialogTitleTip'), {
        confirmButtonText: t('common.confirm'),
        cancelButtonText: t('common.cancel'),
      }).then(() => {
        submitDisableAccount(item)
      })
    }

    function enableAccount (item: Accounts) {
      submitDisableAccount(item)
    }

    function submitDisableAccount (item: Accounts) {
      return service.disableAccount({
        device_id: props.compData.device_id,
        name: item.name,
        status: item.status === AccountStatus.disable ? AccountStatus.enable : AccountStatus.disable
      }).then(() => {
        context.emit('update')
      })
    }

    return {
      AccountStatus,
      TerminalLoginStatus,
      DefenseStatusLabel,
      terminalLoginLabelMap,
      accountStatusLabelMap,
      tipOnlineOnly,
      isLoading,
      formatTimeStamp,
      formatDuration,
      changTab,
      disableAccount,
      enableAccount,
    }
  }
})
